import React from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";

const performances = [
  {
    date: "17 Oct 2025",
    venue: "Tipsy Toad, Newcastle",
    lineup: "Alice Street",
    link: "https://tickets.example.com/tipsytoad",
  },
  {
    date: "7 Nov 2025",
    venue: "Cumberland Arms, Newcastle",
    lineup: "Alice Street",
    link: "https://tickets.example.com/cumberlandarms",
  },
  {
    date: "22 Nov 2025",
    venue: "The Bunker, Sunderland",
    lineup: "Alice Street",
    link: "https://tickets.example.com/thebunker",
  },
  {
    date: "6 Dec 2025",
    venue: "Star and Shadow, Newcastle",
    lineup: "Alice Street",
    link: "https://tickets.example.com/starandshadow",
  },
];

const Performances = () => (
  <Container className="py-5" id="gigs">
    <h2 className="display-4 mb-5 text-center">Upcoming Gigs</h2>
    <Row>
      {performances.map((perf, idx) => (
        <Card key={idx} className="m-3 shadow" style={{ width: "22rem" }}>
          <Card.Body>
            <Card.Title>{perf.date}</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">{perf.venue}</Card.Subtitle>
            <Card.Text>{perf.lineup}</Card.Text>
            {perf.link && (
              <Card.Link href={perf.link} target="_blank" rel="noopener noreferrer">
                Get Tickets
              </Card.Link>
            )}
          </Card.Body>
        </Card>
      ))}
    </Row>
  </Container>
);

export default Performances;
